import { Backdrop, Box, CircularProgress } from '@mui/material';
import React from 'react';
import { withEllipsis } from '../util/StringUtil';

export default function Loading(props: { message?: string }) {
  const { message } = props;
  return (
    <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={true}>
      {message && <div style={{ marginRight: '12px' }}>{withEllipsis(message)}</div>}
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export function SimpleLoading(props: { message?: string }) {
  const { message } = props;
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {message && <div style={{ marginRight: '12px' }}>{withEllipsis(message)}</div>}
      <CircularProgress color="inherit" />
    </Box>
  );
}

export function LoadingSpinner() {
  return <CircularProgress sx={{ mr: '2px', color: '#007ca3', verticalAlign: 'middle' }} size={18} color="inherit" />;
}
